import { inject, Injectable } from '@angular/core';
import {
  BenefitSplitLimits,
  ForemanPromocode,
  ForemanPromocodesPagination,
  GeneratePromocodeParams,
  PromoPaginationParams,
} from '@my-account/const';
import { MyAccountActions, MyAccountSelectors, StateWithMyAccount } from '@my-account/data-access';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForemanPromocodesService {
  private readonly store: Store<StateWithMyAccount> = inject(Store);

  loadBenefitSplitLimits(): void {
    this.store.dispatch(new MyAccountActions.LoadBenefitSplitLimits());
  }

  getBenefitSplitLimits(): Observable<BenefitSplitLimits> {
    return this.store.select(MyAccountSelectors.getBenefitSplitLimitsValue);
  }

  getBenefitSplitLimitsLoading(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getBenefitSplitLimitsLoading);
  }

  getBenefitSplitLimitsError(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getBenefitSplitLimitsError);
  }

  generatePromocode(params: GeneratePromocodeParams): void {
    this.store.dispatch(new MyAccountActions.GeneratePromocode(params));
  }

  getGeneratedPromocode(): Observable<ForemanPromocode> {
    return this.store.select(MyAccountSelectors.getGeneratedPromocodeValue);
  }

  getGeneratePromocodeLoading(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getGeneratedPromocodeLoading);
  }

  getGeneratePromocodeSuccess(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getGeneratedPromocodeSuccess);
  }

  getGeneratePromocodeError(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getGeneratedPromocodeError);
  }

  resetGeneratedPromocode(): void {
    this.store.dispatch(new MyAccountActions.GeneratePromocodeReset());
  }

  loadPromocodes(params: PromoPaginationParams): void {
    this.store.dispatch(new MyAccountActions.LoadForemanPromocodes(params));
  }

  getPromocodes(): Observable<ForemanPromocode[]> {
    return this.store.select(MyAccountSelectors.getForemanPromocodesItems);
  }

  getPromocodesPagination(): Observable<ForemanPromocodesPagination | undefined> {
    return this.store.select(MyAccountSelectors.getForemanPromocodesPagination);
  }

  getPromocodesParams(): Observable<PromoPaginationParams | undefined> {
    return this.store.select(MyAccountSelectors.getForemanPromocodesParams);
  }

  getPromocodesLoading(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getForemanPromocodesListLoading);
  }

  getPromocodesError(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getForemanPromocodesListError);
  }

  resetPromocodes(): void {
    this.store.dispatch(new MyAccountActions.LoadForemanPromocodesReset());
  }
}
